import { useState } from 'react';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer/Footer';
import AppendixTable from '../../../components/Tables/Warren/Appendix';

import { FWNavbar } from '../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';

const WarrenAppendix = () => {
	// modal state
	const [modal, setModal] = useState({
		title: '',
		description: '',
	});

	// modal handlers
	const [showModal, setShowModal] = useState(false);
	const handleShowModal = (title, image, description) => {
		setModal({ title: title, image: image, description: description });
		setShowModal(true);
	};

	return (
		<>
			<Header plant="fort-wayne" />
			<main>
				<wrapper class="section-wrapper">
					<FWNavbar plant="fort-wayne" home />
					<container class="section-container" style={{}}>
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/fort-wayne/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Appendix</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content" style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div class="eq-lock">
								<div class="right-side" style={{}}>
									<h2>OEM Supplier List</h2>
									<h4>Tier 1 – Machine Builder / Integrator:</h4>
									<h5>Inovision</h5>
									<p>20 Corporate Dr, Auburn Hills, MI 48326</p>
									<p></p>
									<p>Phone: 248-299-1915</p>
									<p>Website: https://www.inovision.com/</p>
								</div>
								<AppendixTable />
							</div>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default WarrenAppendix;
